module.exports = __webpack_public_path__ + "static/media/aws.0df26801.jpg";